import { getAll } from '../../api';

const state = {
  details: {
    screenshot: {},
  },
  notes: [],
  sessionLocations: [],
  loading: false,
};

const getters = {
  getDetails(state) {
    return state.details;
  },
  getSessionLocations(state) {
    return state.sessionLocations;
  },
  getNotes(state) {
    return state.notes;
  },
};

const actions = {
  acquireDetails: async ({ commit, dispatch, rootGetters }, payload) => new Promise((resolve, reject) => {
    commit('loading/setLoading', true, { root: true });
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/session?query=${
        encodeURIComponent(
          `{get(type_name: "session", 
            session: {uuid: "${payload}"}, 
            table_name:"${clientTable}", 
          ){
            uuid, 
            area_id, 
            group_id, 
            screen_id,
            ra_number,
            call_status,
            expected_end_at, 
            start_at, 
            checked,
            trip_type, 
            end_at, 
            rider_email, error, 
            success
          }}`,
        )}`,
    )
      .then((res) => {
        dispatch('getSessionCoordinates', payload);
        commit('setData', res.data.data.get);
        dispatch('getNotes', payload);
        resolve(res);
      })
      .catch((err) => {
        commit('loading/setLoading', false, { root: true });
        reject(err);
      });
  }),
  getNotes: async ({ commit, rootGetters }, payload) => new Promise((resolve, reject) => {
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/note?query=${
        encodeURIComponent(
          `{get(type_name: "note", 
            note: {session_id: "${payload}"}, 
            table_name:"${clientTable}", 
            index: "session-index"
          ){
            uuid, 
            screen_id,
            session_id,
            note,
            error, 
            success
          }}`,
        )}`,
    )
      .then((res) => {
        commit('setNotes', res.data.data.get);
        commit('loading/setLoading', false, { root: true });
        resolve(res);
      })
      .catch((err) => {
        commit('loading/setLoading', false, { root: true });
        reject(err);
      });
  }),
  getSessionCoordinates: async ({ commit, rootGetters }, payload) => new Promise((resolve, reject) => {
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/coordinate?query=${
        encodeURIComponent(
          `{getPaginated(type_name: "coordinate", 
            coordinate: {session_id: "${payload}"}, 
            table_name:"${clientTable}", 
            index: "session-index",
            pageSize:"100"
          ){items{
            area_id, 
            group_id, 
            store_id, 
            screen_id, 
            session_id, 
            latitude, 
            longitude, 
            created_at, 
            timestamp, 
            error, 
            success
          }}}`,
        )}`,
    )
      .then((res) => {
        commit('setSessionCoordinates', res.data.data.getPaginated.items);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  uploadDetails: async ({ commit, rootGetters }, payload) => new Promise((resolve, reject) => {
    const newPayload = JSON.stringify(payload).replace(/"([^"]+)":/g, '$1: ');
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/session?query=${
        encodeURIComponent(
          `mutation{update(type_name: "session", 
            session: ${newPayload}, 
            table_name:"${clientTable}", 
          ){
            uuid, 
            area_id, 
            group_id, 
            screen_id,
            ra_number,
            call_status,
            checked,
            expected_end_at, 
            start_at, 
            trip_type, 
            end_at, 
            rider_email, error, 
            success
          }}`,
        )}`,
    )
      .then((res) => {
        commit('setData', [res.data.data.update]);
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  }),
  uploadNote: async ({ dispatch, rootGetters }, payload) => new Promise((resolve, reject) => {
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    const { session_id } = payload;
    payload = JSON.stringify(payload).replace(/"([^"]+)":/g, '$1: ');
    getAll(
      `/note?query=${
        encodeURIComponent(
          `mutation{create(type_name: "note",
            note: ${payload},
            table_name:"${clientTable}",
          ){
            uuid, 
            screen_id,
            session_id,
            note,
            error, 
            success
          }}`,
        )}`,
    )
      .then(() => {
        dispatch('getNotes', session_id);
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  }),
  deleteNote: async ({ dispatch, rootGetters }, payload) => new Promise((resolve, reject) => {
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/note?query=${
        encodeURIComponent(
          `mutation{delete(type_name: "note", 
            uuid: "${payload.uuid}", 
            table_name:"${clientTable}", 
          ){
            uuid, 
            error, 
            success
          }}`,
        )}`,
    )
      .then(() => {
        dispatch('getNotes', payload.session_id);
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  }),
  updateStatus: async ({ commit, rootGetters }, payload) => new Promise((resolve, reject) => {
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/note?query=${
        encodeURIComponent(
          `mutation{update(type_name: "note", 
            table_name:"${clientTable}", 
          ){
            uuid, 
            error, 
            success
          }}`,
        )}`,
    )
      .then(() => {
        commit('setNote', payload);
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  }),
  createStatus: async ({ commit, rootGetters }, payload) => new Promise((resolve, reject) => {
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/note?query=${
        encodeURIComponent(
          `mutation{create(type_name: "note", 
            table_name:"${clientTable}", 
          ){
            uuid, 
            error, 
            success
          }}`,
        )}`,
    )
      .then(() => {
        commit('setNote', payload);
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  }),
};
const mutations = {
  setData(state, payload) {
    if (payload[0].end_at) {
      payload[0].rental_status = 'Checked In';
    } else {
      payload[0].rental_status = 'Checked Out';
    }
    state.details = payload[0];
  },
  setSessionCoordinates(state, payload) {
    state.sessionLocations = [];
    payload.map((loc) => {
      loc.lat = Number(loc.latitude);
      loc.lng = Number(loc.longitude);
      loc.infoOpen = false;
      loc.position = {
        lat: Number(loc.latitude),
        lng: Number(loc.longitude),
      };
      loc.id = loc.screen_id;
    });
    const deviceArray = [];
    payload.sort((a, b) => b.created_at.toString().localeCompare(a.created_at.toString()));
    payload.map((device) => {
      if (deviceArray.filter((e) => e.id === device.id).length > 0) {
        device;
      } else {
        deviceArray.push(device);
      }
    });
    state.devicesReady = true;
    state.sessionLocations = deviceArray;
  },
  setAccessories(state, payload) {
    state.details.accessories = payload;
  },
  setNotes(state, payload) {
    state.notes = payload;
  },
  setNote(state, payload) {
    state;
    payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
